import { Factory } from 'fishery';
import { commodityFactory } from '@trukt/factories/commodityFactory';
import { userFactory } from '@trukt/factories/userFactory';
import { accountFactory } from '@trukt/factories/accountFactory';
import { JobServiceSearchResponse } from './JobService.types';
import { vendorFactory } from '@trukt/utils/vendorFactory';
import { JobListItem } from '@trukt/types/Job';

export const jobGetByIdResultFactory = Factory.define<JobListItem>(({ sequence }) => {
  const client = accountFactory.build();
  return {
    accessorialExpense: '0',
    accessorialRevenue: '0',
    activeContracts: '0',
    baseExpense: '0',
    baseRevenue: '0',
    totalExpense: '0',
    totalRevenue: '0',
    vendorCredit: '0',
    boards: {
      centraldispatch: 'posted',
      dat: 'posted',
      shipcars: 'posted',
      superdispatch: 'posted',
      truckstop: 'posted',
      trukt: 'posted',
    },
    cases: 'cases',
    classification: 'Transport',
    clientContactName: client.name,
    clientName: client.name,
    commodityCount: '0',
    commodityIdentifier: commodityFactory.build().identifier,
    commodityOperable: true,
    consigneeName: 'Consignee Name',
    dateCompleted: '2021-07-20T18:35:04.089Z',
    dateCreated: '2021-07-20T18:35:04.089Z',
    dateVerified: '2021-07-20T18:35:04.089Z',
    dateRequestDeliveryEnd: '2021-07-20T18:35:04.089Z',
    dateRequestDeliveryStart: '2021-07-20T18:35:04.089Z',
    dateRequestPickupEnd: '2021-07-20T18:35:04.089Z',
    dateRequestPickupStart: '2021-07-20T18:35:04.089Z',
    dateScheduledDeliveryEnd: '2021-07-20T18:35:04.089Z',
    dateScheduledDeliveryStart: '2021-07-20T18:35:04.089Z',
    dateScheduledPickupEnd: '2021-07-20T18:35:04.089Z',
    dateScheduledPickupStart: '2021-07-20T18:35:04.089Z',
    dateStarted: '2021-07-20T18:35:04.089Z',
    dateUpdated: '2021-07-20T18:35:04.089Z',
    dateDispatched: '2021-07-20T18:35:04.089Z',
    dateOfferSent: '2021-07-20T18:35:04.089Z',
    distance: '76',
    destinationAddress: '456 Elm St',
    destinationName: 'Destination Name',
    dispatcher: userFactory.build().name,
    grossProfitMargin: '0',
    guid: sequence.toString(),
    isDummy: false,
    lotNumber: 'lotNumber',
    number: `AB${sequence.toString()}`,
    orderGuid: `1000${sequence.toString()}`,
    originAddress: '123 Main St',
    originName: 'Origin Name',
    referenceNumber: 'referenceNumber',
    referrerName: userFactory.build().name,
    salesperson: userFactory.build().name,
    status: 'ready',
    subClassification: 'Transport',
    vendor: vendorFactory.build().name,
    vendorName: vendorFactory.build().name,
    vehicleName: 'vehicleName',
  };
});

export const jobSearchResponseFactory = Factory.define<JobServiceSearchResponse>(() => ({
  next: true,
  page: 1,
  results: jobGetByIdResultFactory.buildList(25),
  rows: 25,
}));
